// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const vikavolt: PokeData = {
  "id": 738,
  "name": "vikavolt",
  "height": 15,
  "weight": 450,
  "base_experience": 225,
  "types": [
    PokeType.BUG,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "vice-grip",
    "guillotine",
    "fly",
    "bite",
    "string-shot",
    "thunderbolt",
    "dig",
    "agility",
    "mud-slap",
    "zap-cannon",
    "spark",
    "crunch",
    "charge",
    "iron-defense",
    "air-slash",
    "x-scissor",
    "bug-buzz",
    "discharge",
    "bug-bite",
    "acrobatics",
    "sticky-web"
  ],
  "moves": [
    "bite",
    "string-shot",
    "thunderbolt",
    "mud-slap",
    "zap-cannon",
    "crunch",
    "air-slash",
    "bug-buzz",
    "bug-bite",
    "acrobatics",
    "sticky-web",
    "volt-switch",
    "pin-rush"
  ],
  "evolution_chain": {
    "id": 379,
    "item": null,
    "species": [
      {
        "name": "grubbin",
        "order": 736,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "charjabug",
        "order": 737,
        "types": [
          PokeType.BUG,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 736,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "vikavolt",
        "order": 738,
        "types": [
          PokeType.BUG,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 737,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": {
              "name": "vast-poni-canyon"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": {
              "name": "blush-mountain"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 119,
    "speed": 64,
    "ability_power": 217
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
